import Vue from 'vue'

import { getUserData } from '@/core/auth/utils'
import { buildOrdersQueryString } from '@/helpers/ordersQueryParams'
import useFormat from '@/views/utils'
import { $themeConfig } from '@themeConfig'

import { guestStore } from '../gql/query'

const {
    GET_GUEST,
    ADD_GUEST,
    UPDATE_GUEST_NAME,
    UPDATE_GUEST_NOTES,
    UPDATE_GUEST_BLACKLIST,
    GET_GUEST_BY_CONTACT,
} = guestStore()

const emptyGuest = {
    created_by: '',
    last_modified_by: '',
    last_name: '',
    is_vip: false,
    is_blacklisted: false,
}

const { formatDateGQL } = useFormat()

const dateFormat = inpDate => inpDate.toISOString()

export default {
    addGuest(ctx, guestData) {
        return new Promise((resolve, reject) => {
            const mergedGuest = { ...emptyGuest, ...guestData }
            mergedGuest.created_date = formatDateGQL(new Date())
            mergedGuest.last_modified_date = formatDateGQL(new Date())
            Vue.axios
                .post($themeConfig.app.gqlUrl, {
                    query: ADD_GUEST,
                    variables: { guest: mergedGuest },
                })
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    fetchOrdersByGuest({ commit, state }, { limit, offset, guest_id }) {
        const getStr = `${
            $themeConfig.app.backUrl
        }/orders?limit=${limit}&offset=${offset}${buildOrdersQueryString(
            state.paramsSearch
        )}&guest_id=${guest_id}`
        return new Promise((resolve, reject) => {
            Vue.axios
                .get(getStr)
                .then(response => {
                    commit('ADD_TO_ORDERS', response.data.orders)
                    commit('SET_COUNT', response.data.count)
                    resolve()
                })
                .catch(error => {
                    console.error(error)
                    reject(error)
                })
        })
    },

    fetchGuest(ctx, id) {
        return new Promise((resolve, reject) => {
            Vue.axios
                .post(`${$themeConfig.app.gqlUrl}?refresh=true`, {
                    query: GET_GUEST,
                    variables: { guestId: id[0] },
                })
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    fetchGuestByContact(ctx, values) {
        return Vue.axios
            .post(`${$themeConfig.app.gqlUrl}?refresh=true`, {
                query: GET_GUEST_BY_CONTACT,
                variables: { contactValues: values },
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                console.error(error)
            })
    },

    updateGuestName(ctx, { id, firstName }) {
        const { login } = getUserData()
        return new Promise((resolve, reject) => {
            Vue.axios
                .post($themeConfig.app.gqlUrl, {
                    query: UPDATE_GUEST_NAME,
                    variables: {
                        id,
                        first_name: firstName,
                        date: dateFormat(new Date()),
                        last_modified_by: login,
                    },
                })
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    updateGuestBlacklist(ctx, { id, is_blacklisted, blacklist_reason }) {
        const { login } = getUserData()
        return new Promise((resolve, reject) => {
            Vue.axios
                .post($themeConfig.app.gqlUrl, {
                    query: UPDATE_GUEST_BLACKLIST,
                    variables: {
                        id,
                        is_blacklisted,
                        blacklist_reason,
                        date: dateFormat(new Date()),
                        last_modified_by: login,
                    },
                })
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    updateGuestNotes({ commit }, { id, notes }) {
        const { login } = getUserData()
        return new Promise((resolve, reject) => {
            Vue.axios
                .post($themeConfig.app.gqlUrl, {
                    query: UPDATE_GUEST_NOTES,
                    variables: {
                        id,
                        notes,
                        date: dateFormat(new Date()),
                        last_modified_by: login,
                    },
                })
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    fetchDublicateOrder({ commit }, orderId) {
        return new Promise((resolve, reject) => {
            Vue.axios
                .get(`${$themeConfig.app.backUrl}/orders/${orderId}/duplicate`)
                .then(response => {
                    commit('SET_OPEN_ORDERS', response.data.orders)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    fetchOrders({ state }, { limit, offset, search }) {
        return new Promise((resolve, reject) => {
            const query = `&phone=${search}`
            const getStr = `${
                $themeConfig.app.backUrl
            }/orders?limit=${limit}&offset=${offset}${buildOrdersQueryString(
                state.paramsSearchForCalling
            )}${query}`
            Vue.axios
                .get(getStr)
                .then(response => {
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
}
